var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSnoozeIconHover = function SvgSnoozeIconHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#A764C6",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9807 17.9083H17.0193V16.567H14.9246L17.0193 14.1648V12.9857H12.9807V14.327H15.1144L12.9807 16.7738V17.9083ZM15 23C14.0067 23 13.0743 22.807 12.2029 22.4211C11.3315 22.0351 10.5728 21.5125 9.92703 20.8534C9.2812 20.1942 8.76921 19.4199 8.39106 18.5305C8.01291 17.6411 7.82384 16.6894 7.82384 15.6756C7.82384 14.6618 8.01291 13.7101 8.39106 12.8207C8.76921 11.9313 9.2812 11.157 9.92703 10.4978C10.5728 9.83867 11.3315 9.31611 12.2029 8.93015C13.0743 8.54419 14.0067 8.35121 15 8.35121C15.9933 8.35121 16.9257 8.54419 17.7971 8.93015C18.6685 9.31611 19.4271 9.83867 20.0729 10.4978C20.7188 11.157 21.2308 11.9313 21.6089 12.8207C21.9871 13.7101 22.1761 14.6618 22.1761 15.6756C22.1761 16.6894 21.9871 17.6411 21.6089 18.5305C21.2308 19.4199 20.7188 20.1942 20.0729 20.8534C19.4271 21.5125 18.6685 22.0351 17.7971 22.4211C16.9257 22.807 15.9933 23 15 23ZM9.93974 7L11.0873 8.16653L7.6429 11.6821L6.5 10.5108L9.93974 7ZM20.0602 7L23.5 10.5108L22.3571 11.6821L18.9127 8.16653L20.0602 7ZM15 21.1894C16.505 21.1894 17.7815 20.6545 18.8298 19.5845C19.8781 18.5145 20.4022 17.2116 20.4022 15.6756C20.4022 14.1396 19.8781 12.8366 18.8298 11.7667C17.7815 10.6967 16.5049 10.1618 15 10.1618C13.495 10.1618 12.2184 10.6968 11.1702 11.7667C10.1219 12.8367 9.59777 14.1396 9.59777 15.6756C9.59777 17.2117 10.1219 18.5146 11.1702 19.5845C12.2185 20.6545 13.4951 21.1894 15 21.1894Z",
    fill: "#A764C6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnoozeIconHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snooze-icon-hover.e95e3c56.svg";
export { ForwardRef as ReactComponent };